module.exports = __webpack_public_path__ + "images/external_images/img/293x351/img1.jpg";